import React, { memo, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import { Text, RangeSlider } from '@beef/ui-kit';

// Utils
import {
  getDefaultIndex,
  getIntegerArray,
  getSliderSteps,
} from '../../../../utils';
import { debounce } from '../../../../../../utils/common';

const DELAY = 300;

const Slide = memo(({
  name,
  limit,
  step,
  unit,
  parentLimit,
  settledLimitsFunc,
  isProcessing,
  isSwitchChecked,
}) => {
  const sliderTitle = (text) => (<Text color="grey95" size="size5-m">{text}</Text>);

  const rangeValue = useRef(null);

  /** Длина массива STEPS слайдера и сам массив */
  const slideLength = parentLimit / step;
  const intArray = getIntegerArray(slideLength + 1);
  const sliderSteps = getSliderSteps(intArray, step);

  const handleChange = useCallback((slideValue) => {
    settledLimitsFunc((prevState) => {
      if (prevState[name] === slideValue) {
        return prevState;
      }
      rangeValue.current = slideValue;
      return { ...prevState, [name]: slideValue };
    });
  }, []);

  const debouncedHandler = debounce(handleChange, DELAY);

  /** Если лимиты не установлены, то применяем лимиты родителя и ползунок слайдера
   * в крайнем правом положении. Если лимиты установлены, то находим defaultIndex */
  const defaultIndex = getDefaultIndex({
    sliderSteps, limit, isSwitchChecked, value: rangeValue.current,
  });

  return (
    <RangeSlider
      title={sliderTitle(name)}
      steps={sliderSteps}
      lastIndex={slideLength}
      unit={unit}
      defaultIndex={defaultIndex}
      onChange={debouncedHandler}
      disabled={isProcessing}
    />
  );
});

Slide.propTypes = {
  name: PropTypes.string,
  limit: PropTypes.number,
  unit: PropTypes.string,
  step: PropTypes.number,
  parentLimit: PropTypes.number,
  settledLimitsFunc: PropTypes.func,
  isProcessing: PropTypes.bool,
  isSwitchChecked: PropTypes.bool,
};

export { Slide };
